(() => {
  const source = document.querySelector('script[data-stas-cookie-label]');
  const label = source?.dataset.stasCookieLabel;
  if (!label || document.documentElement.lang !== 'sr') return;
  const footer = source.closest('.shopify-section') || document.querySelector('footer');
  if (!footer) return;
  const update = () => {
    const links = footer.querySelectorAll('a[href="#shopifyReshowConsentBanner"]');
    for (const link of links) link.textContent = label;
    return links.length > 0;
  };
  if (update()) return;
  const observer = new MutationObserver(() => {
    if (update()) observer.disconnect();
  });
  observer.observe(footer, { childList: true, subtree: true });
})();
